"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = reducer;
exports.addDeckRequest = addDeckRequest;
exports.clearDock = clearDock;
exports.removeDeck = removeDeck;
exports.switchDecks = switchDecks;
exports.rearrangeDecks = rearrangeDecks;
exports.isMeetingOpen = isMeetingOpen;
exports.updateVisitorNetworkStatus = updateVisitorNetworkStatus;

var _userservice = require("../../services/userservice");

var _userservice2 = _interopRequireDefault(_userservice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var ADD_DECK = "add-deck";
var REMOVE_DECK = "remove-deck";
var SWITCH_DECKS = "switch-decks";
var REARRANGE_DECKS = "rearrange-decks";
var UPDATE_VISITOR_NETWORK_STATUS = "update-visitor-network-status";
var CLEAR_DOCK = "clear-dock";

var initialState = { decks: [], visible_decks: [], stacked_decks: [], max_visible_decks: 3 };
function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var newState = void 0,
        decks = void 0,
        visible_decks = void 0,
        stacked_decks = void 0,
        deck = void 0,
        chatIndex = void 0,
        meetingId = void 0,
        deckindex = void 0;

    switch (action.type) {

        case ADD_DECK:
            decks = [].concat(_toConsumableArray(state.decks));
            visible_decks = [].concat(_toConsumableArray(state.visible_decks));
            stacked_decks = [].concat(_toConsumableArray(state.stacked_decks));

            meetingId = action.payload.meeting_id;
            deckindex = decks.map(function (deck) {
                return deck.meeting_id;
            }).indexOf(meetingId);

            if (deckindex >= 0) {
                return state;
            }

            decks.push(action.payload);
            if (visible_decks.length < state.max_visible_decks) {
                visible_decks.push(action.payload);
            } else {
                var _switchVisibleDeck = visible_decks.shift();
                visible_decks.push(action.payload);
                stacked_decks.push(_switchVisibleDeck);
            }

            newState = Object.assign({}, state, { decks: decks, visible_decks: visible_decks, stacked_decks: stacked_decks });
            return newState;

        case REMOVE_DECK:
            decks = [].concat(_toConsumableArray(state.decks));
            visible_decks = [].concat(_toConsumableArray(state.visible_decks));
            stacked_decks = [].concat(_toConsumableArray(state.stacked_decks));

            meetingId = action.payload;
            deckindex = decks.map(function (deck) {
                return deck.meeting_id;
            }).indexOf(meetingId);

            if (deckindex >= 0) {
                decks.splice(deckindex, 1);

                deckindex = stacked_decks.map(function (deck) {
                    return deck.meeting_id;
                }).indexOf(meetingId);
                if (deckindex >= 0) {
                    stacked_decks.splice(deckindex, 1);
                }

                deckindex = visible_decks.map(function (deck) {
                    return deck.meeting_id;
                }).indexOf(meetingId);
                if (deckindex >= 0) {
                    var _switchStackedDeck = stacked_decks.shift();
                    visible_decks.splice(deckindex, 1);

                    if (_switchStackedDeck) visible_decks.push(_switchStackedDeck);
                }
            }

            newState = Object.assign({}, state, { decks: decks, visible_decks: visible_decks, stacked_decks: stacked_decks });
            return newState;

        case SWITCH_DECKS:
            visible_decks = [].concat(_toConsumableArray(state.visible_decks));
            stacked_decks = [].concat(_toConsumableArray(state.stacked_decks));

            if (state.max_visible_decks <= 0) {
                return state;
            }

            var switchVisibleDeck = visible_decks.shift();
            deck = stacked_decks.find(function (chat) {
                return chat.meeting_id === action.payload.meeting_id;
            });
            chatIndex = stacked_decks.indexOf(deck);
            var switchStackedDeck = stacked_decks.splice(chatIndex, 1);

            visible_decks.push(switchStackedDeck[0]);
            stacked_decks.push(switchVisibleDeck);

            newState = Object.assign({}, state, { visible_decks: visible_decks, stacked_decks: stacked_decks });
            return newState;

        case REARRANGE_DECKS:
            var payload = action.payload,
                i = null,
                deck_to_move = null,
                total_decks_to_move = null;

            if (state.decks.length === 0) {
                return state;
            }

            visible_decks = [].concat(_toConsumableArray(state.visible_decks));
            stacked_decks = [].concat(_toConsumableArray(state.stacked_decks));
            var max_visible_decks = state.max_visible_decks;

            if (payload === state.max_visible_decks) {
                return state;
            }

            if (payload < max_visible_decks) {
                if (payload >= visible_decks.length) {
                    return state;
                }
                total_decks_to_move = visible_decks.length - payload;
                for (i = 0; i < total_decks_to_move; i++) {
                    deck_to_move = visible_decks.pop();
                    stacked_decks.push(deck_to_move);
                }
                max_visible_decks = payload;
            }

            if (payload > max_visible_decks) {
                total_decks_to_move = payload - max_visible_decks;
                for (i = 0; i < total_decks_to_move; i++) {
                    deck_to_move = stacked_decks.shift();
                    if (deck_to_move) visible_decks.push(deck_to_move);
                }
                max_visible_decks = payload;
            }

            newState = Object.assign({}, state, { visible_decks: visible_decks, stacked_decks: stacked_decks, max_visible_decks: max_visible_decks });
            return newState;

        case UPDATE_VISITOR_NETWORK_STATUS:
            decks = [].concat(_toConsumableArray(state.decks));
            visible_decks = [].concat(_toConsumableArray(state.visible_decks));
            stacked_decks = [].concat(_toConsumableArray(state.stacked_decks));

            deck = decks.find(function (deck) {
                return deck.visitor.profile_type === action.payload.profile_type && deck.visitor.profile_id === action.payload.user_id;
            });
            if (!deck) {
                return state;
            }

            deck.visitor.visitorNetworkStatus = action.payload.is_online;

            deck = visible_decks.find(function (deck) {
                return deck.visitor.profile_type === action.payload.profile_type && deck.visitor.profile_id === action.payload.user_id;
            });
            if (deck) {
                deckindex = visible_decks.indexOf(deck);
                visible_decks[deckindex].visitor.visitorNetworkStatus = action.payload.is_online;
            }

            deck = stacked_decks.find(function (deck) {
                return deck.visitor.profile_type === action.payload.profile_type && deck.visitor.profile_id === action.payload.user_id;
            });
            if (deck) {
                deckindex = stacked_decks.indexOf(deck);
                stacked_decks[deckindex].visitor.visitorNetworkStatus = action.payload.is_online;
            }

            newState = Object.assign({}, state, { decks: decks, visible_decks: visible_decks, stacked_decks: stacked_decks });
            return newState;

        case CLEAR_DOCK:
            return initialState;

        default:
            return state;
    }
}

// private functions
function addDeck(payload) {
    return {
        type: ADD_DECK,
        payload: payload
    };
}

// action dispatchers
function addDeckRequest(meeting_details, participants) {

    return function (dispatch, getState) {
        var userDetails = _userservice2.default.getUser();
        var chat_title = null;
        if (meeting_details.profile_type === "guest") {
            chat_title = meeting_details.name + "_" + meeting_details.profile_id;
        } else {
            chat_title = meeting_details.name;
        }
        var chatProps = {
            meeting_id: meeting_details.id,
            title: chat_title,
            themeColor: null,
            currentUserId: userDetails.id,
            currentUserName: userDetails.name,
            currentUserPic: null,
            visitorId: meeting_details.profile_id,
            participantsData: {
                meetingId: meeting_details.id,
                participant_list: participants
            },
            visitor: {
                profile_type: meeting_details.profile_type,
                profile_id: meeting_details.profile_id,
                name: meeting_details.name,
                visitorNetworkStatus: meeting_details.visitorNetworkStatus
            }
        };

        dispatch(addDeck(chatProps));
    };
}

function clearDock() {
    return {
        type: CLEAR_DOCK
    };
}

function removeDeck(meetingId) {
    return {
        type: REMOVE_DECK,
        payload: meetingId
    };
}

function switchDecks(payload) {
    return {
        type: SWITCH_DECKS,
        payload: payload
    };
}

function rearrangeDecks(payload) {
    return {
        type: REARRANGE_DECKS,
        payload: payload
    };
}

function isMeetingOpen(meetingId) {
    return function (dispatch, getState) {
        var currentDecks = getState().docker.decks;

        var deckIndex = currentDecks.map(function (deck) {
            return deck.meeting_id;
        }).indexOf(meetingId);

        if (deckIndex >= 0) {
            return true;
        } else {
            return false;
        }
    };
}

function updateVisitorNetworkStatus(payload) {
    return {
        type: UPDATE_VISITOR_NETWORK_STATUS,
        payload: payload
    };
}


// WEBPACK FOOTER //
// ../chat/lib/components/dock/docker_reducer.js